import { Financiera } from "src/app/catalagos/entidades/financiera";

export class EstatusCredito {

    id: number;
    descripcion: string;
    financiera: Financiera;
}
